<div class="bottom-sheet-wrapper d-block d-md-none">
	<div #backdrop @fade *ngIf="show" class="bottom-sheet-backdrop"></div>
	<div @slideUp *ngIf="show" class="bottom-sheet" [class.h-100]="fullscreen">
		<div class="bottom-sheet-expand">
			<div class="bottom-sheet-bar"></div>
		</div>
		<div class="bottom-sheet-title">
			<div class="d-flex justify-content-between mx-3 my-2">
				<h6 class="text-secondary mb-0 align-self-end">
					Bottom Sheet Title
				</h6>
				<i
					*ngIf="fullscreen"
					(click)="emitCloseBtnEvent()"
					class="bi bi-x-lg bottom-sheet-close-btn"
				></i>
			</div>
		</div>
		<div class="bottom-sheet-body">
			<ng-content></ng-content>
		</div>
	</div>
</div>
